export default __webpack_public_path__ + "static/media/profile.71e11915.jpg";